import React, { useState } from "react";
import { Table, Button, Tooltip, message } from "antd";
import { ExportOutlined } from "@ant-design/icons";
import moment from "moment";
import { useIntl } from "react-intl";
import { injectTimewatchEvents } from "../../../api/server";
import { useSelector } from "react-redux";

const TimewatchEventsTable = ({
  timewatchEvents,
  isLoadingTimewatch,
  holidays,
  branchId,
  currentDate,
  reload,
}) => {
  const intl = useIntl();
  const activeEmployee = useSelector(
    (state) => state.employeeDetails.activeEmployee
  );
  const [isExporting, setIsExporting] = useState(false);

  const handleExport = async () => {
    try {
      setIsExporting(true);
      const params = {
        month: currentDate.month() + 1,
        year: currentDate.year(),
      };

      await injectTimewatchEvents(branchId, activeEmployee?.id, params);
      message.success(
        intl.formatMessage({ id: "app.scheduling.export_timewatch.success" })
      );
    } catch (error) {
      message.error(
        intl.formatMessage({ id: "app.scheduling.export_timewatch.error" })
      );
    } finally {
      setIsExporting(false);
      reload();
    }
  };

  const columns = [
    {
      title: intl.formatMessage({ id: "app.scheduling.timewatch.date" }),
      dataIndex: "date",
      key: "date",
      render: (text) => moment(text).format("DD/MM/YYYY"),
      width: "100px",
    },
    {
      title: intl.formatMessage({ id: "app.scheduling.timewatch.dayOfWeek" }),
      dataIndex: "date",
      key: "dayOfWeek",
      render: (text) => {
        return moment(text).format("dd");
      },
      width: "40px",
    },
    {
      title: intl.formatMessage({ id: "app.scheduling.timewatch.entrance" }),
      dataIndex: "entrance_date",
      key: "entrance_date",
      render: (text) => (text ? moment(text).format("HH:mm") : "-"),
      width: "58px",
    },

    {
      title: intl.formatMessage({ id: "app.scheduling.timewatch.exit" }),
      dataIndex: "exit_date",
      key: "exit_date",
      render: (text) => (text ? moment(text).format("HH:mm") : "-"),
      width: "58px",
    },
    {
      title: intl.formatMessage({ id: "app.scheduling.timewatch.hours" }),
      key: "hours",
      width: "62px",

      render: (_, record) => {
        const entrance = moment(record.entrance_date);
        const exit = moment(record.exit_date);
        if (entrance.isValid() && exit.isValid()) {
          const duration = moment.duration(exit.diff(entrance));
          return Number(duration.asHours().toFixed(2));
        }
        return "-";
      },
    },
  ];

  const dataSource = timewatchEvents.map((event, index) => ({
    ...event,
    key: index,
    date: event.entrance_date || event.exit_date,
  }));

  // determine the row class name
  const getRowClassName = (record) => {
    const date = moment(record.date);
    const isHoliday = holidays.some((holiday) =>
      moment(holiday.date).isSame(date, "day")
    );

    let className = "timewatch-event-row";
    if (date.day() === 6) {
      className += " saturday-row";
    }
    if (isHoliday) {
      className += " saturday-row";
    }

    return className;
  };

  return (
    <Table
      columns={columns}
      dataSource={dataSource}
      pagination={false}
      scroll={{
        y: window.innerHeight - 240,
      }}
      size="small"
      bordered
      rowClassName={getRowClassName}
      loading={isLoadingTimewatch}
      title={() => (
        <div
          className="timewatch-events-title"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "0 8px 0 0",
          }}
        >
          {intl.formatMessage({ id: "app.scheduling.timewatchEvents" })}
          <Tooltip
            title={intl.formatMessage({
              id: "app.scheduling.timewatchEvents_export",
            })}
          >
            <Button
              type="text"
              icon={<ExportOutlined />}
              onClick={handleExport}
              loading={isExporting}
            />
          </Tooltip>
        </div>
      )}
    />
  );
};

export default TimewatchEventsTable;
